import Phaser from "phaser";
import { SCALE, TILES_BY_SCREEN, TILE_SIZE } from "../utils/constants";
import CRTFilter from "../utils/CRTShaderFX";
import UI from "../components/UI";
import { translate } from "../utils/localization";
import Level1 from "../components/levels/level_1";
import dbManager from "../utils/dbManager";
import { stopGlobalScore } from "../utils/globalScore";

export default class IntroScene extends Phaser.Scene {
  constructor() {
    super("IntroScene");

    // intro images
    this.images = {
      tiamat: null,
      sky: null,
      clouds: null,
      storm: null,
      ground: null,
      ground_high: null,
      ground_break: null,
      comet: null,
      people_climbing: null,
      people_paying: null,
      people_paying_high: null,
      people_descending: null,
      people_falling: null,
      people_jumping: null,
    };
    this.texts = {
      line1: null,
      line2: null,
      line3: null,
      level_title: null,
    };
    this.sounds = {
      background_music: null,
      dramatic_music: null,
      earthquake: null,
    };
  }

  preload() {
    dbManager.reset();
  }

  createAnimations() {
    this.anims.create({
      key: "closeUp_Mary",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [0] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Marduk",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [1] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Dwarf",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [2] }),
      repeat: 0,
    });
    this.anims.create({
      key: "closeUp_Tiamat",
      frames: this.anims.generateFrameNumbers("closeUp", { frames: [5] }),
      repeat: 0,
    });
    // this.anims.create({
    //   key: 'closeUp_Pickaxe',
    //   frames:this.anims.generateFrameNumbers('closeUpItems', { frames: [ 6 ] }),
    //   repeat: 0,
    // })
    // this.anims.create({
    //   key: 'closeUp_Mushroom',
    //   frames:this.anims.generateFrameNumbers('closeUpItems', { frames: [ 7 ] }),
    //   repeat: 0,
    // })
  }
  createSounds() {
    this.sounds.background_music = this.sound.add("opening_peace", {
      loop: true,
    });
    this.sounds.dramatic_music = this.sound.add("opening_quakes", {
      loop: true,
    });
    this.sounds.earthquake = this.sound.add("earthquake");
  }
  createTextPlaceholders() {
    this.texts.line1 = this.createTextLine(-4);
    this.texts.line2 = this.createTextLine(-3);
    this.texts.line3 = this.createTextLine(-2);

    this.texts.level_title = this.createTextLine(0);
    this.texts.level_title.setPosition(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2
    );
    this.texts.level_title._shadow.setPosition(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2
    );
    this.texts.level_title.setOrigin(0.5, 0.5);
    this.texts.level_title._shadow.setOrigin(0.5, 0.5);
    this.texts.level_title.alpha = 0;
    this.texts.level_title._shadow.alpha = 0;
    this.texts.level_title.setText(translate("stage_1.title"));
  }
  createTextLine(lineNumber) {
    const LINE_HEIGHT = 10 * SCALE;
    const LINE_REF = lineNumber < 0 ? this.cameras.main.height : 0;
    const LINE_REF_FACTOR = lineNumber < 0 ? -1 : 1;
    const XPOS = 2 * SCALE;
    const YPOS =
      LINE_REF + Math.abs(LINE_HEIGHT * lineNumber) * LINE_REF_FACTOR;
    const lineShadow = this.add
      .text(80, 10, "", {
        fontFamily: "GameGirl",
        fontSize: "10px",
        fill: "#ffffff",
      })
      .setScale(SCALE)
      .setPosition(XPOS, YPOS);

    lineShadow.displayHeight = LINE_HEIGHT;
    const line = this.add
      .text(lineShadow.x + 5, lineShadow.y - 5, "", lineShadow.style)
      .setScale(SCALE);
    line.displayHeight = lineShadow.displayHeight;
    lineShadow.setTint(0x333333);

    // line.setData('shadow', lineShadow)
    line._setText = line.setText;
    line._shadow = lineShadow;
    line.setText = (txt) => {
      line._shadow.setText(txt);
      line._setText(txt);
    };

    return line;
  }
  createImages() {
    this.images.sky = this.createFullscreenImage("IntroSky");
    this.images.clouds = this.createFullscreenImage("IntroClouds");
    this.images.tiamat = this.createFullscreenImage("IntroTiamat");
    this.images.ground = this.createFullscreenImage("IntroGround");
    this.images.comet = this.createFullscreenImage("IntroComet");
    this.images.storm = this.createFullscreenImage("IntroStorm");
    this.images.ground_high = this.createFullscreenImage("IntroGroundHigh");
    this.images.ground_break = this.createFullscreenImage("IntroGroundBreak");
    this.images.people_climbing = this.createFullscreenImage(
      "IntroPeopleClimbing"
    );
    this.images.people_falling =
      this.createFullscreenImage("IntroPeopleFalling");
    this.images.people_paying =
      this.createFullscreenImage("IntroPeoplePraying");
    this.images.people_paying_high = this.createFullscreenImage(
      "IntroPeoplePrayingHigh"
    );
    this.images.people_descending = this.createFullscreenImage(
      "IntroPeopleDescending"
    );
    this.images.people_jumping =
      this.createFullscreenImage("IntroPeopleJumping");
  }
  createFullscreenImage(name) {
    let image = this.add.image(
      this.cameras.main.width / 2,
      this.cameras.main.height / 2,
      name
    );
    image.setScale(SCALE).setScrollFactor(0);
    image.alpha = 0;
    return image;
  }

  async animEnterTiamat(duration) {
    return new Promise((res) => {
      this.tweens.add({
        targets: this.images.tiamat,
        alpha: 1,
        // scale: scale,
        duration,
        ease: "Linear",
        onComplete: res,
      });
    });
  }
  async animExitTiamat(duration) {
    return new Promise((res) => {
      this.tweens.add({
        targets: this.images.tiamat,
        alpha: 0,
        duration,
        ease: "Linear",
        onComplete: res,
      });
    });
  }
  async animEnterWorld() {
    return new Promise((res) => {
      this.tweens.add({
        targets: this.images.sky,
        // scale: scale,
        alpha: 1,
        duration: 2500,
        ease: "Linear",
        // onComplete: res
      });
      this.tweens.add({
        targets: this.images.clouds,
        // scale: scale,
        alpha: 1,
        delay: 3000,
        duration: 2500,
        ease: "Linear",
        // onComplete: res
      });
      this.tweens.add({
        targets: this.images.comet,
        // scale: scale,
        alpha: 1,
        delay: 6000,
        duration: 2500,
        ease: "Linear",
        // onComplete: res
      });
      this.tweens.add({
        targets: this.images.ground,
        // scale: scale,
        alpha: 1,
        delay: 9000,
        duration: 2500,
        ease: "Linear",
        onComplete: res,
      });
    });
  }
  async animEnterPeople() {
    const DELAY_TO_START = 3000;
    return new Promise((res) => {
      this.tweens.add({
        targets: this.images.people_climbing,
        delay: DELAY_TO_START,
        alpha: 1,
        duration: 1000,
        yoyo: true,
        hold: 1000,
        ease: "Linear",
        // onComplete: res
      });
      this.tweens.add({
        targets: this.images.people_paying,
        // scale: scale,
        alpha: 1,
        delay: DELAY_TO_START + 2000,
        duration: 1000,
        ease: "Linear",
        onComplete: res,
      });
    });
  }
  async animGroundTransition() {
    return new Promise((res) => {
      this.tweens.add({
        targets: [this.images.people_paying, this.images.ground],
        alpha: 0,
        duration: 1000,
        ease: "Linear",
      });
      this.tweens.add({
        targets: [this.images.people_paying_high, this.images.ground_high],
        alpha: 1,
        // delay: 1000,
        duration: 1000,
        ease: "Linear",
      });
      // anim people
      this.tweens.add({
        targets: [this.images.people_paying_high],
        alpha: 0,
        delay: 2000,
        duration: 1000,
        ease: "Linear",
      });
      this.tweens.add({
        targets: [this.images.people_descending],
        alpha: 1,
        delay: 2000,
        duration: 1000,
        ease: "Linear",
        completeDelay: 2000,
        onComplete: res,
      });
    });
  }
  async animPage(duration) {
    return new Promise((res) => {
      this.texts.line1.alpha =
        this.texts.line2.alpha =
        this.texts.line3.alpha =
          0;

      this.tweens.add({
        targets: [
          this.texts.line1,
          this.texts.line1._shadow,
          this.texts.line2,
          this.texts.line2._shadow,
          this.texts.line3,
          this.texts.line3._shadow,
        ],
        alpha: 1,
        duration: 1000,
        completeDelay: duration, // delay before onComplete
        onComplete: () => {
          this.tweens.add({
            targets: [
              this.texts.line1,
              this.texts.line1._shadow,
              this.texts.line2,
              this.texts.line2._shadow,
              this.texts.line3,
              this.texts.line3._shadow,
            ],
            alpha: 0,
            duration: 1000,
            onComplete: res,
          });
        },
      });
    });
  }
  async animPage1(duration) {
    this.texts.line1.setText(translate("intro.story_page_1.line_1"));
    this.texts.line2.setText(translate("intro.story_page_1.line_2"));

    return this.animPage(duration);
  }
  async animPage2(duration) {
    this.texts.line1.setText(translate("intro.story_page_2.line_1"));
    this.texts.line2.setText(translate("intro.story_page_2.line_2"));
    this.texts.line3.setText(translate("intro.story_page_2.line_3"));

    return this.animPage(duration);
  }
  async animPage3(duration) {
    this.texts.line1.setText(translate("intro.story_page_3.line_1"));
    this.texts.line2.setText(translate("intro.story_page_3.line_2"));
    this.texts.line3.setText(translate("intro.story_page_3.line_3"));

    return this.animPage(duration);
  }
  async animPage4(duration) {
    // this.texts.line1.setPosition(0, 0)
    this.texts.line1.setText(translate("intro.story_page_4.line_1"));
    this.texts.line2.setText(translate("intro.story_page_4.line_2"));
    this.texts.line3.setText("");
    return this.animPage(duration);
  }
  async animPage5(duration) {
    this.texts.line1.setText(translate("intro.story_page_5.line_1"));
    this.texts.line2.setText(translate("intro.story_page_5.line_2"));
    this.texts.line3.setText("");
    return this.animPage(duration);
  }
  async animEarthquake() {
    this.cameras.main.shake(2000, 0.005);
    this.sounds.earthquake.play();
  }
  async animStormEnter() {
    return new Promise((res) => {
      this.tweens.add({
        targets: [this.images.storm],
        alpha: 1,
        // delay: 2000,
        duration: 2000,
        ease: "Linear",
        completeDelay: 2000,
        onComplete: () => {
          // hide underlay elements so later we can anim storm fade out to black
          this.images.clouds.alpha = 0;
          this.images.comet.alpha = 0;
          this.images.ground.alpha = 0;
          this.images.sky.alpha = 0;
          res();
        },
      });
    });
  }
  async animEnterFalling() {
    return new Promise((res) => {
      this.tweens.add({
        targets: [this.images.ground_high, this.images.people_descending],
        alpha: 0,
        delay: 1000,
        duration: 1000,
        ease: "Linear",
      });
      this.tweens.add({
        targets: [this.images.ground_break, this.images.people_falling],
        alpha: 1,
        delay: 1000,
        duration: 1000,
        ease: "Linear",
        completeDelay: 2000,
        onComplete: res,
      });
    });
  }

  async animEnterJumping() {
    return new Promise((res) => {
      this.tweens.add({
        targets: [this.images.people_falling],
        alpha: 0,
        delay: 1000,
        duration: 1000,
        ease: "Linear",
      });
      this.tweens.add({
        targets: [this.images.people_jumping],
        alpha: 1,
        delay: 1000,
        duration: 1000,
        ease: "Linear",
        completeDelay: 5000,
        onComplete: res,
      });
    });
  }
  async animLevelTitle() {
    return new Promise((res) => {
      this.tweens.add({
        targets: [
          this.images.people_jumping,
          this.images.ground_break,
          this.images.storm,
        ],
        alpha: 0,
        delay: 1000,
        duration: 1000,
        ease: "Linear",
      });
      this.tweens.add({
        targets: [this.texts.level_title, this.texts.level_title._shoadow],
        alpha: 1,
        delay: 1000,
        duration: 1000,
        ease: "Linear",
        completeDelay: 5000,
        onComplete: res,
      });
    });
  }
  playMusic() {
    this.sounds.background_music.play();
  }
  playDramaticMusic() {
    this.tweens.add({
      targets: this.sounds.background_music,
      volume: 0,
      duration: 500,
      completeDelay: 1000, // delay before onComplete
      onComplete: () => {
        this.sounds.background_music.stop();
        this.sounds.dramatic_music.play();
        // this.showThirdDialogs()
      },
    });
  }
  exitMusic() {
    this.tweens.add({
      targets: this.sounds.dramatic_music,
      volume: 0,
      duration: 1500,
      onComplete: () => {
        this.sounds.dramatic_music.stop();
      },
    });
  }
  async create() {
    stopGlobalScore(this);
    this.cameras.main.setPostPipeline(CRTFilter);
    new UI(this, true);

    this.createAnimations();
    this.createSounds();
    this.createImages();
    this.createTextPlaceholders();

    // animations

    this.playMusic();
    this.animEnterTiamat(5000);
    await this.animPage1(8000);

    this.animEnterWorld();
    await this.animPage2(8000);
    this.animEnterPeople();
    await this.animPage3(8000);

    await this.showFirstDialogs();

    await this.animExitTiamat(5000);
    await this.animGroundTransition();
    await this.showSecondDialogs();

    this.playDramaticMusic();
    await this.animStormEnter();

    this.animEarthquake();
    this.animEnterFalling();
    await this.animPage4(4000);

    this.animPage5(6000);
    await this.animEnterJumping();

    this.exitMusic();
    await this.animLevelTitle();

    this.cameras.main.fade(1000, 0, 0, 0);
    this.cameras.main.once("camerafadeoutcomplete", () =>
      this.scene.start("GameScene", { levelName: Level1.key })
    );
  }

  showFirstDialogs() {
    this.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Tiamat", "closeUp_Marduk"],
      participantNames: ["Mary", "Tiamat", "Marduk"],
      conversation: [
        {
          who: "closeUp_Tiamat",
          text: [translate("intro.dialog_1.tiamat_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("intro.dialog_1.mary_say_1")],
        },
        {
          who: "closeUp_Tiamat",
          text: [translate("intro.dialog_1.tiamat_say_2")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("intro.dialog_1.mary_say_2")],
        },
        {
          who: "closeUp_Tiamat",
          text: [translate("intro.dialog_1.tiamat_say_3")],
        },
        {
          who: "closeUp_Marduk",
          text: [translate("intro.dialog_1.marduk_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("intro.dialog_1.mary_say_3")],
        },
        {
          who: "closeUp_Tiamat",
          text: [translate("intro.dialog_1.tiamat_say_4")],
        },
        {
          who: "closeUp_Tiamat",
          text: [translate("intro.dialog_1.tiamat_say_5")],
        },
        {
          who: "closeUp_Tiamat",
          text: [translate("intro.dialog_1.tiamat_say_6")],
        },
      ],
    });

    // hack to get control after dialogue close
    return new Promise((res) => {
      this.levels = {
        current: {
          pause: () => false,
          resume: () => {
            setTimeout(res, 1000);
          },
        },
      };
    });
  }

  showSecondDialogs() {
    this.events.emit("dialogue:show", {
      participants: ["closeUp_Mary", "closeUp_Marduk"],
      participantNames: ["Mary", "Marduk"],
      conversation: [
        {
          who: "closeUp_Marduk",
          text: [translate("intro.dialog_2.marduk_say_1")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("intro.dialog_2.mary_say_1")],
        },
        {
          who: "closeUp_Marduk",
          text: [translate("intro.dialog_2.marduk_say_2")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("intro.dialog_2.mary_say_2")],
        },
        {
          who: "closeUp_Marduk",
          text: [translate("intro.dialog_2.marduk_say_3")],
        },
        {
          who: "closeUp_Mary",
          text: [translate("intro.dialog_2.mary_say_3")],
        },
        {
          who: "closeUp_Marduk",
          text: [translate("intro.dialog_2.marduk_say_4")],
        },
      ],
    });
    // hack to get control after dialogue close
    return new Promise((res) => {
      this.levels = {
        current: {
          pause: () => false,
          resume: () => {
            setTimeout(res, 1000);
          },
        },
      };
    });
  }

  showThirdDialogs() {
    // hack to get control after dialogue close
    this.levels = {
      current: {
        pause: () => false,
        resume: () => {
          this.tweens.add({
            targets: this.quakesMusic,
            volume: 0,
            duration: 500,
            completeDelay: 500,
            onComplete: () => {
              this.scene.start("GameScene", { level: 1 });
            },
          });
        },
      },
    };

    this.events.emit("dialogue:show", {
      participants: [],
      conversation: [
        {
          who: "",
          text: ["- A fissure opens up", "beneath Marduk and he", "falls into"],
        },
        {
          who: "",
          text: ["- Mary rolls her eyes", "and jumps in after"],
        },
      ],
    });
  }
  animateIntro() {
    this.cameras.main.pan(
      this.renderer.width,
      this.renderer.height / 2,
      2000,
      "Sine.easeInOut"
    );
    this.cameras.main.once(Phaser.Cameras.Scene2D.Events.PAN_COMPLETE, () => {
      this.cameras.main.shake(2000, 0.02);
      this.tweens.add({
        targets: this.children.getByName("dark"),
        y: -this.renderer.height * 0.3,
        duration: 2000,
      });
      this.tweens.add({
        targets: this.children.getByName("partner"),
        y: this.renderer.height,
        delay: 2000,
        duration: 2000,
        ease: "Sine.in",
      });
      this.tweens.add({
        targets: this.children.getByName("player"),
        y: this.renderer.height,
        x: {
          value: this.children.getByName("player").x + 150,
          duration: 1000,
          ease: "Cubic.easeOut",
        },
        delay: 4000,
        duration: 2000,
        ease: "Back.easeInOut",
        onComplete: () => {
          this.cameras.main.fade(1000, 0, 0, 0);
          this.cameras.main.once(
            "camerafadeoutcomplete",
            () => void this.scene.start("GameScene", { level: 1 })
          );
        },
      });
    });
  }
}
